import * as CM from '@emersya/mpa-components-manager';
import { NS as PlannerFurnitureEditorNS } from '@emersya/mpa-engine/src/app/client/components/viewer/planner/furniture/Editor/PlannerFurnitureEditor';

class TotalExpoPlannerFurnitureEditorComponent extends PlannerFurnitureEditorNS.Component {
	override productTileId = 'totalExpo-viewer-planner-furniture-productTile';
};

export namespace NS {
	export const Component = TotalExpoPlannerFurnitureEditorComponent;
	export type Component = TotalExpoPlannerFurnitureEditorComponent;
	export type Configuration = PlannerFurnitureEditorNS.Configuration;
}
import manifestXMLSource from './PlannerFurnitureEditor.xml';

CM.Manager.declare({
	id: 'totalExpo-viewer-planner-screen-editor',
	type: TotalExpoPlannerFurnitureEditorComponent,
	manifest: manifestXMLSource
});

CM.Manager.declare({
	id: 'totalExpo-viewer-planner-plant-editor',
	type: TotalExpoPlannerFurnitureEditorComponent,
	manifest: manifestXMLSource
});
